import styled from "styled-components";
import { Button, Box } from "@mui/material";
import { deviceSpec } from "breakpoints";

export const HeaderTitle = styled.h3`
  font-size: 14pt;
`;

export const LinkButton = styled("button")`
  margin-left: auto;
  box-shadow: 2px 2px 4.2px hsl(0deg 0% 0% / 0.17);
  padding: 0.5rem 1rem;
  border-radius: 51px !important;
  background-color: ${({ theme }) => theme.name === 'light-theme' ? theme.colors.lightButton : theme.colors.sidebarcolor};
  color: ${({ theme }) => theme.name === 'light-theme' ? theme.colors.white : ""} !important;
`;